export default __webpack_public_path__ + "static/media/platezh.a356fc4d.jpg";